<template>
  <el-dialog
    :title="ADJUST_TITLE[dialogConfig.type]"
    v-model="visible"
    width="60%"
    :close-on-click-modal="false"
    style="overflow: hidden"
  >
    <el-collapse
      v-model="activeName"
      style="overflow-y: auto; height: 55vh"
      v-loading="loading"
    >
      <el-collapse-item title="盘点信息" name="msg">
        <el-descriptions
          border
          :column="3"
          v-if="dialogConfig.type == 'detail'"
        >
          <el-descriptions-item
            v-for="item in descriptionList"
            :key="item.value"
            :label="item.label"
            :span="item.span || 1"
            width="16%"
          >
            <span v-if="item.value == 'status'" class="my_class">
              {{ formData[item.value]?.desc }}</span
            >
            <span v-else class="my_class">{{ formData[item.value] }}</span>
          </el-descriptions-item>
        </el-descriptions>
        <el-form
          :model="formData"
          ref="ruleRef"
          label-width="140px"
          :rules="rules"
          v-else
        >
          <el-row :gutter="10">
            <el-col :span="8">
              <el-form-item label="盘点单号： " prop="number">
                <el-input
                  v-model="formData.number"
                  placeholder="系统生成"
                  :maxlength="40"
                  v-no-space
                  :disabled="true"
                />
              </el-form-item>
            </el-col>
            <!-- <el-col :span="8">
              <el-form-item label="盘点人员： " prop="checkUser">
                <el-select
                  v-model="formData.checkUser"
                  placeholder="请选择盘点人"
                  style="width: 100%"
                  :disabled="dialogConfig.type == 'edit'"
                >
                  <el-option
                    v-for="item in userList"
                    :key="item.id"
                    :label="item.nikeName"
                    :value="item.userCode"
                  />
                </el-select>
              </el-form-item>
            </el-col> -->
            <el-col :span="8">
              <el-form-item label="盘点仓库：" prop="warehouseId">
                <el-select
                  v-model="formData.warehouseId"
                  placeholder="请选择仓库"
                  style="width: 100%"
                  :disabled="dialogConfig.type == 'edit'"
                  @change="changeWarehouse"
                >
                  <el-option
                    v-for="item in stashList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  />
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <!-- <el-row :gutter="10">
            <el-col :span="8"
              ><el-form-item label="计划开始日期： " prop="planStart">
                <el-date-picker
                  v-model="formData.planStart"
                  style="width: 100%"
                  type="datetime"
                  placeholder="计划开始日期"
                  @change="formData.planEnd = null"
                  format="YYYY-MM-DD HH:mm:ss"
                  value-format="YYYY-MM-DD HH:mm:ss"
                  :disabled="dialogConfig.type == 'edit'"
                /> </el-form-item
            ></el-col>
            <el-col :span="8"
              ><el-form-item label="计划结束日期： " prop="planEnd">
                <el-date-picker
                  v-model="formData.planEnd"
                  type="datetime"
                  style="width: 100%"
                  placeholder="计划结束日期"
                  :disabled-date="disabledPlanEndTime"
                  format="YYYY-MM-DD HH:mm:ss"
                  value-format="YYYY-MM-DD HH:mm:ss"
                  :disabled="dialogConfig.type == 'edit'"
                /> </el-form-item
            ></el-col>
          </el-row> -->
          <el-row :gutter="10">
            <el-col>
              <el-form-item label="备注： " prop="remark">
                <el-input
                  v-model="formData.remark"
                  type="textarea"
                  :rows="3"
                  :maxlength="200"
                  show-word-limit
                />
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </el-collapse-item>
      <el-collapse-item title="盘点明细" name="detail">
        <div class="flex">
          <el-text type="primary">总数量： {{ tableData.length }}</el-text>
          <el-form
            :model="formData"
            :rules="rules"
            :inline="true"
            ref="subRuleRef"
            v-if="dialogConfig.type == 'edit'"
          >
            <el-form-item label="盘点开始时间" prop="startTime">
              <el-date-picker
                v-model="formData.startTime"
                type="datetime"
                placeholder="盘点开始日期"
                @change="formData.finishTime = null"
                format="YYYY-MM-DD HH:mm:ss"
                value-format="YYYY-MM-DD HH:mm:ss"
              />
            </el-form-item>
            <el-form-item label="盘点结束时间" prop="finishTime">
              <el-date-picker
                v-model="formData.finishTime"
                type="datetime"
                placeholder="盘点结束日期"
                :disabled-date="disabledEndTime"
                format="YYYY-MM-DD HH:mm:ss"
                value-format="YYYY-MM-DD HH:mm:ss"
              />
            </el-form-item>
          </el-form>

          <el-button
            type="primary"
            @click="handleMaterielSelect()"
            v-if="dialogConfig.type == 'add'"
            >选择物料</el-button
          >
        </div>
        <el-table
          :header-cell-style="{ 'text-align': 'center' }"
          :cell-style="{ 'text-align': 'center' }"
          class="mt10"
          :data="tableData"
        >
          <el-table-column label="序号" type="index" width="55" />
          <template v-for="item in columns" :key="item.prop">
            <el-table-column
              :label="item.label"
              :prop="item.prop"
              show-overflow-tooltip
            >
              <template #default="{ row }">
                <el-input-number
                  v-model="row[item.prop]"
                  :controls="false"
                  v-if="item.isInput"
                  :min="-99999"
                  :max="99999"
                  :precision="4"
                  style="width: 100%"
                  @blur="checkCountChange(row)"
                />
              </template>
            </el-table-column>
          </template>
          <el-table-column label="操作" v-if="dialogConfig.type == 'add'">
            <template #default="{ row, $index }">
              <el-button type="primary" link @click="handleRemove(row, $index)"
                >移除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </el-collapse-item>
    </el-collapse>
    <template #footer>
      <span class="dialog-footer">
        <el-button @click="handleCancel()">取消</el-button>
        <el-button
          type="primary"
          @click="handleSubmit()"
          :disabled="buttonLoading"
          v-if="dialogConfig.type != 'detail'"
        >
          保存
        </el-button>
      </span>
    </template>

    <!-- 物料选择组件 -->
    <WarehouseManagementcheck
      ref="selectRef"
      type="out"
      :validateZero="false"
      @selectDone="materielSelectDone"
    />
  </el-dialog>
</template>

<script setup>
import { reactive, ref } from "vue";
import WarehouseManagementcheck from "@/components/WarehouseManagementcheck.vue";
import { ADJUST_TITLE } from "@/constants";
import { queryCheckById, insertCheck, updateCheck } from "@/api/check";
import useStashList from "@/views/hooks/useStashList";
import { ElMessage, tabsEmits } from "element-plus";
import useUserList from "@/views/hooks/useUserList";
import { throttle } from "lodash";

const { stashList } = useStashList();

const { userList } = useUserList();

const emits = defineEmits(["afterSave"]);

// 弹窗控制器
const visible = ref(false);

// 表单ref
const ruleRef = ref(null);

const subRuleRef = ref(null);

// 物料选择ref
const selectRef = ref(null);

// 当前物料列表中已经存在的id
const alreadyExistIds = ref([]);

// 表单数据
const formData = ref({
  number: null,
  checkUser: null,
  warehouseId: null,
  checkDate: null,
  planStart: null,
  planEnd: null,
  startTime: null,
  finishTime: null,
});

// 描述列表
const descriptionList = ref([
  {
    label: "盘点单号",
    value: "number",
  },
  // {
  //   label: "盘点人员",
  //   value: "checkUserName",
  // },
  {
    label: "仓库",
    value: "warehouseName",
  },
  // {
  //   label: "盘点状态",
  //   value: "status",
  // },
  // {
  //   label: "盘点开始日期",
  //   value: "startTime",
  // },
  // {
  //   label: "盘点结束日期",
  //   value: "finishTime",
  // },
  {
    label: "备注",
    value: "remark",
    span: 3,
  },
]);

// 表单校验规则
const rules = reactive({
  // number: [
  //   { required: true, message: "请输入单号", trigger: "blur" },
  //   {
  //     pattern: /^[a-zA-Z0-9]+$/,
  //     message: "只能输入英文和数字",
  //     trigger: "blur",
  //   },
  // ],
  checkUser: [{ required: true, message: "请选择盘点人", trigger: "blur" }],
  warehouseId: [{ required: true, message: "请选择仓库", trigger: "blur" }],
  checkDate: [{ required: true, message: "请选择盘点日期", trigger: "blur" }],
  planStart: [
    { required: true, message: "请选择计划开始日期", trigger: "blur" },
  ],
  planEnd: [{ required: true, message: "请选择计划结束日期", trigger: "blur" }],
  startTime: [
    { required: true, message: "请选择盘点开始日期", trigger: "blur" },
  ],
  finishTime: [
    { required: true, message: "请选择盘点结束日期", trigger: "blur" },
  ],
});

// collapse组件默认展开节点(全部展开)
const activeName = ref(["msg", "detail"]);

// 表格列配置
const columns = ref([]);

// 弹窗loading
const loading = ref(false);

// 保存按钮loading
const buttonLoading = ref(false);

// 接收参数
const dialogConfig = ref({});

// 物料列表
const tableData = ref([]);

// 新增编辑函数
const fns = reactive({
  add: insertCheck, // 新增
  edit: updateCheck, // 编辑
});

// 选择物料
const handleMaterielSelect = () => {
  if (!formData.value.warehouseId) return ElMessage.warning("请先选择仓库");
  selectRef.value?.handleDialogOpen(
    alreadyExistIds.value,
    formData.value.warehouseId,
    false
  );
};

// 弹窗打开
const handleDialogOpen = (config) => {
  dialogConfig.value = config;
  formData.value = {
    number: null,
    checkUser: null,
    warehouseId: null,
    checkDate: null,
    planStart: null,
    planEnd: null,
    startTime: null,
    finishTime: null,
  };
  tableData.value = [];
  alreadyExistIds.value = [];
  ruleRef.value?.resetFields();
  if (config.type != "add") {
    queryDetail(config.row.id);
  }
  if (config.type == "add") {
    columns.value = [
      {
        label: "物料编号",
        prop: "materialDTO.number",
      },
      {
        label: "物料名称",
        prop: "materialDTO.name",
      },
      {
        label: "物料类别",
        prop: "materialDTO.categoryName",
      },
      {
        label: "品牌",
        prop: "materialDTO.brand",
      },
      {
        label: "规格型号",
        prop: "materialDTO.model",
      },
      {
        label: "单位",
        prop: "materialDTO.unit",
      },

      {
        label: "仓库",
        prop: "warehouseDTO.orgName",
      },
      {
        label: "库存数量",
        prop: "quantity",
      },
      {
        label: "盘点结果",
        prop: "changeQuantity",
        isInput: true,
      },
    ];
  } else if (config.type == "detail") {
    columns.value = [
      {
        label: "物料编号",
        prop: "materialDTO.number",
      },
      {
        label: "物料名称",
        prop: "materialDTO.name",
      },
      {
        label: "物料类别",
        prop: "materialDTO.categoryName",
      },
      {
        label: "品牌",
        prop: "materialDTO.brand",
      },
      {
        label: "规格型号",
        prop: "materialDTO.model",
      },
      {
        label: "单位",
        prop: "materialDTO.unit",
      },
      {
        label: "库存数量",
        prop: "beforeQuantity",
      },
      {
        label: "盘点结果",
        prop: "changeQuantity",
        isInput: false,
      },
      {
        label: "盘点后数量",
        prop: "afterQuantity",
      },
      // {
      //   label: "库位",
      //   prop: "position",
      // },
      // {
      //   label: "库位描述",
      //   prop: "positionDesc",
      // },
      // {
      //   label: "库存数量",
      //   prop: "inventoryNumber",
      // },
    ];
  }
  visible.value = true;
};

// 物料选择结束
const materielSelectDone = (val) => {
  tableData.value = [...val];
  tableData.value.map((i) => {
    (i.inventoryId = i.id), (i.materialName = i.name);
    i.position = i.warehousePositionName;
  });
  alreadyExistIds.value = [];
  tableData.value.forEach((item) => {
    alreadyExistIds.value.push(item.quantityId);
  });
};

// 表单结束时间必须大于开始时间
const disabledEndTime = (time) => {
  if (!formData.value.startTime) return true;
  return (
    Date.parse(formData.value.startTime.replace(/-/g, "/")) > time.getTime()
  );
};

// 计划结束时间必须小于开始时间
const disabledPlanEndTime = (time) => {
  if (!formData.value.planStart) return true;
  return (
    Date.parse(formData.value.planStart.replace(/-/g, "/")) > time.getTime()
  );
};

// 点击保存
const handleSubmit = () => {
  let flag = 0;
  tableData.value.forEach((item) => {
    if (item.changeQuantity < -item.quantity) {
      flag = 1;
    }
  });
  if (flag == 1) return ElMessage.error("盘点结果错误");
  if (buttonLoading.value) return;
  buttonLoading.value = true;
  ruleRef.value?.validate((valid) => {
    if (valid) {
      if (dialogConfig.value.type == "edit") {
        if (!formData.value.startTime || !formData.value.finishTime) {
          buttonLoading.value = false;
          return ElMessage.error("请选择盘点开始、结束时间");
        }
      }
      const checkDetailReqs = [...tableData.value];
      checkDetailReqs.map((i) => {
        i.id = null;
        i.beforeQuantity = i.quantity;
      });
      let reqBody = {
        ...formData.value,
        checkDetailReqs,
      };
      adjustCheck(reqBody);
    } else {
      buttonLoading.value = false;
    }
  });
};

// 点击取消
const handleCancel = () => {
  ruleRef.value?.resetFields();
  visible.value = false;
};

// 新增或编辑
const adjustCheck = (req) => {
  fns[dialogConfig.value.type](req).then((res) => {
    if (res.code == "2000") {
      ElMessage.success("操作成功");
      emits("afterSave");
      visible.value = false;
    }
  });
  setTimeout(() => {
    buttonLoading.value = false;
  }, 1000);
};

// 根据id获取信息
const queryDetail = (id) => {
  loading.value = true;
  queryCheckById(id)
    .then((res) => {
      Object.assign(formData.value, res.data);
      tableData.value = res.data.checkDetailDTOList;

      alreadyExistIds.value = [];
      tableData.value.forEach((item) => {
        alreadyExistIds.value.push(item.quantityId);
        checkCountChange(item);
      });
    })
    .finally(() => {
      loading.value = false;
    });
};

// 切换仓库
const changeWarehouse = () => {
  tableData.value = [];
};

// 点击表格移除
const handleRemove = (row, index) => {
  tableData.value.splice(index, 1);

  const arr = alreadyExistIds.value.filter((id) => id != row.quantityId);

  alreadyExistIds.value = arr;
};

// 盘点数量变化
const checkCountChange = (row) => {
  // if (row.count == null) return (row.changeQuantity = "未盘点");
  // if (row.count > row.inventoryNumber) {
  //   row.changeQuantity = "盘盈";
  // } else if (row.count < row.inventoryNumber) {
  //   row.changeQuantity = "盘亏";
  // } else if (row.count == row.inventoryNumber) {
  //   row.changeQuantity = "盘平";
  // }
};

defineExpose({
  handleDialogOpen,
});
</script>

<style scoped>
.flex {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}

.mt10 {
  margin-top: 10px;
}
.my_class {
  max-width: 100%;
  word-break: break-all;
  word-wrap: break-word;
}
</style>
